import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CustomerSelectionModal from "./CustomerSelectionModal";
import PartSelectionModal from "./PartSelectionModal";
import CustomerService from "../../../Customer/Controller/CustomerController";
import CustomerContactService from "../../../Customer/Controller/CustomerContactController";
import CustomerSiteService from "../../../Customer/Controller/CustomerSiteController";
import QuotationService from "../../Controller/QuotationController";
import PartService from "../../../Parts/Controller/PartController";
import StockDiscountCategoryService from "../../../Parts/Controller/StockDiscountCategoryController";
import QuotationStatusService from "../../../Setup/controller/QuotationStatusController/QuotationStatusController";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import { handleChange, handleSubmit } from "../../Controller/CreateQuotationController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import CurrencyTextField from "../../../Jobs/View/JobForms/CurrencyTextField";
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
import VatTaxService from '../../../Setup/controller/VatTaxController/VatTaxController';
import HelpSite from "../../../Common/HelpLink";
import useSaleOrder from "./useSaleOrder";
import useServiceJob from "./useServiceJob";
import useInvoice from "./useInvoice";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import CustomerDiscountService from "../../../Customer/Controller/CustomerDiscountController";
import CustomerCategoryDiscountService from "../../../Customer/Controller/CustomerCategoryDiscountController"
import CustomerStockService from "../../../Customer/Controller/CustomerStockController";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import LeadService from "../../../Lead/Controller/LeadController"
import OppurtunityService from "../../../Oppurtunity/Controller/OppurtunityController"

import LeadSelectionModal from "./LeadSelectionModal";
import OpportunitySelectionModal from "./OpportunitySelectionModal";
import SendEmail from "../../../Common/SendEmailAttachment";
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import DescriptionModal from "../../../SaleOrder/View/SaleOrderForms/DescriptionModal";
import LeadUserDefineFieldsSection from '../../../Lead/Views/LeadForms/LeadUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";

import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from "../../../../config/config";
import Draggable from 'react-draggable';
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { handleSubmit as handleCustomerSubmit } from "../../../Customer/Controller/CreateCustomerDetailController";
import { PDFDocument } from "pdf-lib";

import ContactSelectionModal from "../../../Jobs/View/JobForms/ContactSelection";
import SiteSelectionModal from "../../../Jobs/View/JobForms/SiteSelectionModal";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
    Opportunities: 18,
    Invoices: 22,
};
function QuotationDetail({ QuotationID, onSuccess, onClose, ClientCompanyID, CustomerType, LeadID, OpportunityID, MainPage, isLock, Tab }) {

    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [isClosed, SetIsClosed] = useState("0");
    const [loading, setLoading] = useState(false);

    const [customerTax, setCustomerTax] = useState("0.00");
    const [customertaxType, setCustomertaxType] = useState("0");

    const [customerCategorytaxType, setCustomerCategoryType] = useState("0");
    const [customerCategoryTax, setCustomerCategoryTax] = useState("0");
    const [quantityTax, setQuantityTax] = useState("0");

    const [quantityBreak, setQuantityBreak] = useState();
    const [customerStockList, setCustomerStockList] = useState([]);

    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [pdfBlob, setPdfBlob] = useState(null);
    const [pdfAttachment, setPdfAttachment] = useState(null); // Store PDF for Email
    const [assignedModules, setAssignedModules] = useState(new Set());
    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const [descriptionText, setDescriptionText] = useState("");
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
    const [KeyNameList, setKeyNames] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [includeTerms, setIncludeTerms] = useState(true);

    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, QuotationID, "6");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };

    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };

    const tableRef = useRef();
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    QuotationID = localStorage.getItem("QuotationID");
    const [formData, setFormData] = useState({
        type: "1",
        CustomerID: 0,
        LeadID: 0,
        OpportunityID: 0,
        CustomerName: '',
        OpportunityName: '',
        LeadName: '',
        FK_ClientBranch_ID: 0,
        FK_ClientContact_ID: 0,
        AccountRef: '',
        dec_DiscountAmount: "0.00",
        mon_TotalPrice: "0.00",
        GrandTotal: "0.00",
        dec_DiscountNETTotal: "0.00",
        vc_CustomerOrderNumber: "",
        dt_QuotationDate: getCurrentDate(),
        int_DiscountType: 0,
        IsPercentage: false,
        FK_QuotationStatus_ID: "1",
        mon_TotalPriceO: "0.00",
        mon_TotalPriceGR: "0.00",
        FK_Issue_ID: "0",
        vc_User5: "",
        snt_PaymentMethod: "0",
        HostCompanyAddress: "",
        bnt_OrderNumber: "",

        vc_DeliveryFullName: "",
        vc_DeliveryAddress1: "",
        vc_DeliveryTown: "",
        vc_DeliveryCounty: "",
        vc_DeliveryPostCode: "",
        CourierID: "0",
        ClientType: "0",
        ClientCompanyName: "",
        Forename: "",
        Address1: "",
        Surname: "",
        BranchName: "",
        ContactName: ""

    });
    const resetForm = () => {

        setFormData({
            type: "1",
            CustomerID: 0,
            LeadID: 0,
            OpportunityID: 0,
            CustomerName: '',
            OpportunityName: '',
            LeadName: '',
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0,
            AccountRef: '',
            dec_DiscountAmount: "0.00",
            mon_TotalPrice: "0.00",
            GrandTotal: "0.00",
            dec_DiscountNETTotal: "0.00",
            vc_CustomerOrderNumber: "",
            dt_QuotationDate: getCurrentDate(),
            int_DiscountType: 0,
            IsPercentage: false,
            FK_QuotationStatus_ID: "1",
            mon_TotalPriceO: "0.00",
            mon_TotalPriceGR: "0.00",
            FK_Issue_ID: "0",
            vc_User5: "",
            snt_PaymentMethod: "0",
            mon_TotalPriceG: "0.00",
            CourierID: "0",
            ClientType: "0",
            ClientCompanyName: "",
            Forename: "",
            Address1: "",
            Surname: "",
            BranchName: "",
            ContactName: ""
        });
    };
    const [CustomerList, setCustomer] = useState([]);

    const [LeadList, setLeadList] = useState([]);
    const [OpportunityList, setOpportunityList] = useState([]);

    const [LeadModal, setLeadModal] = useState(false);
    const [OpportunityModal, setOpportunityModal] = useState(false);
    const [CustomerModal, setCustomerModal] = useState(false);



    const [CustomerContactList, setCustomerContact] = useState([]);
    const [CustomerSiteList, setCustomerSite] = useState([]);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [QuotationStatusList, setQuotationStatusData] = useState([]);
    const { theme } = useContext(ThemeContext);
    const [partList, setPartData] = useState([]);
    const [selectedParts, setSelectedParts] = useState([]);
    const [showPartModal, setShowPartModal] = useState(false);
    const [DiscountsList, setDiscounts] = useState([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [currencyList, setCurrencies] = useState([]);
    const [currencyCustomerSymbol1, setCurrencyCustomerSymbol1] = useState('');
    const [currencyCostValue1, setCostCurrencyValue1] = useState('');
    const [BaseCurrency, setBaseCurrency] = useState('');
    const [vatTax, setVatTax] = useState('0.00');
    const [convRate, setConRate] = useState('0.00');
    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchVatTax = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const vatTax = await VatTaxService.GetVatTaxLabel(redirectCallback);
            if (vatTax.length > 0) {
                setVatTax(vatTax[0].vatTax);
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchDefaultCurrency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setBaseCurrency(listOfCurreny[0].Symbol);

        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchLeadDetail = async (leadId) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const LeadDetail = await LeadService.GetLeadByID(redirectCallback, leadId);
            if (LeadDetail.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    type: "2",
                    LeadID: LeadDetail[0].ID,
                    LeadName: LeadDetail[0].vc_Company

                }));

                let ConvRate = "1.00";
                if (LeadDetail[0].vc_CurrencySymbol != null && LeadDetail[0].vc_CurrencySymbol != "" && LeadDetail[0].vc_CurrencySymbol != "undefined") {
                    setCurrencyCustomerSymbol1(LeadDetail[0].vc_CurrencySymbol);
                    ConvRate = await convertCurrency(BaseCurrency, LeadDetail[0].vc_CurrencySymbol, currencyList, "0");
                }
                else {
                    setCurrencyCustomerSymbol1(BaseCurrency);
                    ConvRate = await convertCurrency(BaseCurrency, BaseCurrency, currencyList, "0");
                }


                await fetchQuotationItems(LeadDetail[0].vc_CurrencySymbol, ConvRate);
            }
            if (LeadID > 0) {
                await handleLeadSelect(LeadDetail[0]);
            }


        } catch (error) {
            console.error('Error fetching asset details:', error);
        }
    };
    const fetchOpportunityDetail = async (ID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const OppDetail = await OppurtunityService.GetOppurtunityByID(redirectCallback, ID);

            OppDetail[0].CType = "Opportunity";
            OppDetail[0].CompanyName = OppDetail[0].vc_Company;
            await handleCustomerSelect(OppDetail[0]);
            return OppDetail[0];
        } catch (error) {
            console.error('Error fetching asset details:', error);
        }
    };
    useEffect(() => {
        const initializeData = async () => {

            SetIsClosed("0");
            await fetchCurrency();
            await fetchDefaultCurrency();
            // fetchVatTax();
            await fetchCustomers();
            await fetchLeads();
            await fetchOpportunity();
            await fetchQuotationStatus();
            fetchAssignedModules()
            if (QuotationID > 0) {
                await fetchQuotationDetail(CustomerType);
                await fetchKeyNames();
            }
            else {
                await resetForm();
                setSelectedParts([]);

                if (ClientCompanyID > 0) {
                    await fetchCustomerData(ClientCompanyID);
                }
                if (LeadID > 0) {
                    await fetchLeadDetail(LeadID);

                }
                if (OpportunityID > 0) {
                    await fetchOpportunityDetail(OpportunityID);

                }
            }
            //  fetchParts(0);
            await fetchDiscount();
            await fetchKeyNames();

        };
        initializeData();
    }, [QuotationID, Tab]);
    useEffect(() => {
        const updatedParts = selectedParts.map(part => {
            const salesPrice = parseFloat(part.mon_SalesPrice || 0);
            const netSalesPrice = parseFloat(part.net_SalesPrice || 0);
            const netVATPrice = parseFloat(part.net_VATPrice || 0);
            const quantity = parseFloat(part.vc_UnitOfSale || 0);
            const dec_Discount = parseFloat(part.dec_Discount || 0);
            const discount = (salesPrice * quantity) * ((dec_Discount) / 100);
            const total = netSalesPrice; // Assuming total is just the net sales price
            const totalVAT = netVATPrice;
            return { ...part, discount, total, totalVAT };
        });
        const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_SalesPrice || 0), 0);
        let totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.total || 0), 0);
        let totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount || 0), 0);
        const totalVATPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.totalVAT || 0), 0);
        const carriage = parseFloat(formData.mon_DeliveryNetTotal || 0);
        if (formData.int_DiscountType === "3" || formData.int_DiscountType === 3) {
            totalDiscountedAmount = Math.round(parseFloat(totalDiscountedAmount).toFixed(2)) + Math.round(parseFloat((totalNetSalesPrice * formData.dec_DiscountAmount) / 100).toFixed(2));
            totalNetSalesPrice = (totalNetSalesPrice) * ((100 - formData.dec_DiscountAmount) / 100);

        }
        else if (formData.int_DiscountType === "4" || formData.int_DiscountType === 4) {
            totalDiscountedAmount = Math.round(totalDiscountedAmount) + Math.round(formData.dec_DiscountAmount);
            totalNetSalesPrice = totalNetSalesPrice - formData.dec_DiscountAmount;

        }

        const orderTotal = parseFloat(totalNetSalesPrice).toFixed(2);
        const grandTotal = parseFloat(totalNetSalesPrice + totalVATPrice + carriage).toFixed(2);

        setFormData((prevFormData) => ({
            ...prevFormData,
            dec_DiscountNETTotal: parseFloat(totalDiscountedAmount).toFixed(2),
            mon_TotalPrice: parseFloat(orderTotal).toFixed(2),
            mon_TotalPriceO: parseFloat(totalVATPrice).toFixed(2),
            mon_TotalPriceG: grandTotal

        }));
    }, [selectedParts, formData.int_DiscountType, formData.dec_DiscountAmount, formData.mon_DeliveryNetTotal]);


    const fetchCustomers = async () => {
        try {

            const redirectCallback = () => navigate('/');
            const listOfCustomers = await CustomerService.GetCustomerOpportunites();
            setCustomer(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchLeads = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const leadData = await LeadService.GetAllLeadForQuotations(redirectCallback);
            setLeadList(leadData);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchOpportunity = async () => {
        try {
            const redirectCallback = () => navigate('/');
            // const oppurtunityData = await OppurtunityService.GetAllOpportunityForQuotations(redirectCallback);
            const listOfCustomers = await CustomerService.GetCustomerOpportunites();
            setOpportunityList(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchQuotationStatus = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const list = await QuotationStatusService.GetQuotationStatus(redirectCallback);
            setQuotationStatusData(list);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchDiscountCategory = async (CustomerID) => {
        try {
            const redirectCallback = () => navigate('/');
            let listOfDiscounts = await CustomerDiscountService.GetAllCustomerDiscount(redirectCallback, CustomerID);
            listOfDiscounts = listOfDiscounts.find(cust => cust.IsDefault === 1);
            return listOfDiscounts;
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchCustomerCategoryDiscount = async (StockCategoryID) => {
        try {
            const redirectCallback = () => navigate('/');
            let listOfDiscounts = await PartService.QuantityBreakDiscount(redirectCallback, StockCategoryID);
            return listOfDiscounts;
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchCustomerStock = async (CustomerID) => {
        try {
            const redirectCallback = () => navigate('/');
            const stockList = await CustomerStockService.CustomerStockCategory(redirectCallback, CustomerID);
            return stockList;

        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    const fetchCustomerContact = async (BranchID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setCustomerContact([]);
            const listOfCustomerContacts = await CustomerContactService.GetContactByBranch(redirectCallback, BranchID);
            setCustomerContact(listOfCustomerContacts);
            if (listOfCustomerContacts.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientContact_ID: listOfCustomerContacts[0].ClientContactID,
                    ContactName: `${listOfCustomerContacts[0].Title || ''} ${listOfCustomerContacts[0].FirstName || ''} ${listOfCustomerContacts[0].SurName || ''}`.trim(),
                }));
            }
        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };

    const fetchCustomersSites = async (customerID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const listOfCustomerSites = await CustomerSiteService.GetAllCustomersSites(redirectCallback, customerID);
            setCustomerSite(listOfCustomerSites);
            const headOfficeSite = listOfCustomerSites.find(site => site.HeadOffice === 1);
            if (headOfficeSite) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                    BranchName: headOfficeSite.BranchName,
                }));
                await fetchCustomerContact(headOfficeSite.ClientBranchID);
            } else if (listOfCustomerSites.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                    BranchName: headOfficeSite.BranchName,
                }));
                await fetchCustomerContact(listOfCustomerSites[0].ClientBranchID);
            }
        } catch (error) {
            console.error('Error fetching customer sites:', error);
        }
    };

    const fetchParts = async (ClientCompanyID = 0) => {
        try {
            const redirectCallback = () => navigate('/');
            const data = await QuotationService.GetAllParts(redirectCallback, ClientCompanyID);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching parts:', error);
        }
    };
    const populateCustomerSiteContactAccount = async (quotation) => {

        debugger;
        const customerId = quotation.CustomerID;
        const redirectCallback = () => navigate('/');
        const listOfCustomers = await CustomerService.GetAllCustomersForQuotation(redirectCallback);
        const selectedCustomer = listOfCustomers.find(customer => customer.ClientCompanyID === parseInt(customerId));
        const newCurrencySymbol = (selectedCustomer.vc_CurrencySymbol != null && selectedCustomer.vc_CurrencySymbol !== "" && selectedCustomer.vc_CurrencySymbol !== "undefined")
            ? selectedCustomer.vc_CurrencySymbol
            : BaseCurrency;
        setVatTax(selectedCustomer.dec_Rate);
        //  fetchParts(selectedCustomer.ClientCompanyID);
        //Level 1 Discounting
        setCustomerTax(selectedCustomer.dec_Amount ?? 0.00);
        setCustomertaxType(selectedCustomer.FK_DiscountType_ID ?? 0);
        // END Level 1 Discounting

        //Level 2 Discounting

        // Level 2 Discount


        const CustomerStock = await fetchCustomerStock(selectedCustomer.ClientCompanyID);
        if (CustomerStock.length > 0) {
            setCustomerCategoryType(CustomerStock[0].FK_DiscountType_ID);
            setCustomerCategoryTax(CustomerStock[0].dec_Amount);

            const StockCategryList = await StockDiscountCategoryService.GetStockByCategoryID(redirectCallback, CustomerStock[0].FK_StockCategory_ID);
            setCustomerStockList(StockCategryList);
            // Level 3 Discount
            let QuantityBreakDiscount = await fetchCustomerCategoryDiscount(CustomerStock[0].FK_StockCategory_ID);
            setQuantityBreak(QuantityBreakDiscount);
        }
        //End Level 2 Discount
        //End Level 3 Discounting

        let ConvRate = "1.00";
        if (selectedCustomer.vc_CurrencySymbol != null && selectedCustomer.vc_CurrencySymbol != "" && selectedCustomer.vc_CurrencySymbol != "undefined") {
            setCurrencyCustomerSymbol1(selectedCustomer.vc_CurrencySymbol);
            ConvRate = await convertCurrency(BaseCurrency, selectedCustomer.vc_CurrencySymbol, currencyList, "0");
            setConRate(ConvRate);
        }
        else {
            setCurrencyCustomerSymbol1(BaseCurrency);
            ConvRate = await convertCurrency(BaseCurrency, BaseCurrency, currencyList, "0");
            setConRate(ConvRate);
        }
        await fetchQuotationItems(newCurrencySymbol, ConvRate);

        await fetchCustomersSites(customerId);
        await fetchCustomerContact(quotation.FK_ClientBranch_ID);
        setFormData({
            ...quotation,
            CustomerID: customerId,
            AccountRef: quotation.AccountRef,
            FK_ClientBranch_ID: quotation.FK_ClientBranch_ID,
            BranchName: quotation.BranchName,
            FK_ClientContact_ID: quotation.FK_ClientContact_ID,
            dt_QuotationDate: new Date(quotation.dt_QuotationDate).toISOString().split('T')[0],
        });



    };
    const fetchQuotationDetail = async (customerType) => {
        try {
            const redirectCallback = () => navigate('/');

            if (QuotationID > 0) {
                const quotationDetail = await QuotationService.GetQuotationByID(redirectCallback, QuotationID, customerType);
                const quotation = quotationDetail[0];

                const formattedDate = new Date(quotation.dt_QuotationDate).toISOString().split('T')[0];


                setFormData(prev => ({
                    ...prev,
                    ...quotation,
                    dt_QuotationDate: new Date(quotationDetail[0].dt_QuotationDate).toISOString().split('T')[0],
                    CustomerName: quotation.CompanyName,
                    HostCompanyAddress: quotation.HostCompanyAddress,
                    bnt_OrderNumber: quotation.bnt_OrderNumber,
                    vc_DeliveryFullName: quotation.vc_DeliveryFullName,
                    vc_DeliveryAddress1: quotation.vc_DeliveryAddress1,
                    vc_DeliveryTown: quotation.vc_DeliveryTown,
                    vc_DeliveryCounty: quotation.vc_DeliveryCounty,
                    vc_DeliveryPostCode: quotation.vc_DeliveryPostCode

                }));

                debugger;
                if (quotation.FK_Issue_ID > 0 || quotation.FK_SalesOrder_ID > 0) {
                    SetIsClosed("1");
                }
                if (CustomerType.toString() === "1") {
                    await populateCustomerSiteContactAccount(quotationDetail[0]);
                }
                else if (CustomerType.toString() === "2") {
                    const leadList = await LeadService.GetLeadByID(redirectCallback, quotationDetail[0].LeadID);
                    const selectedLead = leadList.find(lead => lead.ID === quotationDetail[0].LeadID);
                    const newCurrencySymbol = (selectedLead.vc_CurrencySymbol != null && selectedLead.vc_CurrencySymbol !== "" && selectedLead.vc_CurrencySymbol !== "undefined")
                        ? selectedLead.vc_CurrencySymbol
                        : BaseCurrency;
                    const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
                    setCurrencyCustomerSymbol1(newCurrencySymbol);
                    setVatTax(selectedLead.dec_Rate ?? 0.00);
                    setConRate(ConversionRate);
                    await fetchQuotationItems(newCurrencySymbol, ConversionRate);
                }
                else if (CustomerType.toString() === "3") {
                    const opportunityList = await OppurtunityService.GetOppurtunityByID(redirectCallback, quotationDetail[0].OpportunityID);
                    const selectedOpportunity = opportunityList.find(opportunity => opportunity.ID === quotationDetail[0].OpportunityID);
                    const newCurrencySymbol = (selectedOpportunity.vc_CurrencySymbol != null && selectedOpportunity.vc_CurrencySymbol !== "" && selectedOpportunity.vc_CurrencySymbol !== "undefined")
                        ? selectedOpportunity.vc_CurrencySymbol
                        : BaseCurrency;
                    const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
                    setCurrencyCustomerSymbol1(newCurrencySymbol);
                    setVatTax(selectedOpportunity.dec_Rate ?? 0.00);
                    setConRate(ConversionRate);
                    await fetchQuotationItems(newCurrencySymbol, ConversionRate);
                }
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const fetchCustomerData = async (customerID) => {
        try {
            const redirectCallback = () => navigate('/');

            const customerData = await CustomerService.GetCustomerByID(redirectCallback, customerID);
            if (customerData.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    type: "1",
                    CustomerName: customerData[0].CompanyName,
                    AccountRef: customerData[0].AccountRef,
                    HostCompanyAddress: customerData[0].HostCompanyAddress,
                    bnt_OrderNumber: customerData[0].bnt_OrderNumber,
                    vc_DeliveryFullName: customerData[0].vc_DeliveryFullName,
                    vc_DeliveryAddress1: customerData[0].vc_DeliveryAddress1,
                    vc_DeliveryTown: customerData[0].vc_DeliveryTown,
                    vc_DeliveryCounty: customerData[0].vc_DeliveryCounty,
                    vc_DeliveryPostCode: customerData[0].vc_DeliveryPostCode,
                    CType: "Customer"
                }));
            }


            let ConvRate = "1.00";
            if (customerData[0].vc_CurrencySymbol != null && customerData[0].vc_CurrencySymbol != "" && customerData[0].vc_CurrencySymbol != "undefined") {
                setCurrencyCustomerSymbol1(customerData[0].vc_CurrencySymbol);
                ConvRate = await convertCurrency(BaseCurrency, customerData[0].vc_CurrencySymbol, currencyList, "0");
            }
            else {
                setCurrencyCustomerSymbol1(BaseCurrency);
                ConvRate = await convertCurrency(BaseCurrency, BaseCurrency, currencyList, "0");
            }

            await fetchCustomersSites(customerID);
            await fetchQuotationItems(customerData[0].vc_CurrencySymbol, ConvRate);
            if (ClientCompanyID > 0) {
                await handleCustomerSelect(customerData[0]);
            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setIsChanged(true);
        // Allow input of decimal points
        const isDecimalInput = name === "dec_DiscountAmount" && /^-?\d*\.?\d*$/.test(value);
        if (!isDecimalInput && name === "dec_DiscountAmount") return;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));

        if (name === "int_DiscountType" || name === "dec_DiscountAmount") {
            const discountValue = name === "int_DiscountType" ? value : formData.int_DiscountType;
            let amountValue = name === "dec_DiscountAmount" ? value : formData.dec_DiscountAmount;

            if (discountValue === "0") {
                amountValue = "0";
            }

            setFormData((prevFormData) => ({
                ...prevFormData,
                int_DiscountType: discountValue,
                dec_DiscountAmount: amountValue,

            }));
        }
    };

    const calculateQuantityBreakDiscount = (quantity, StockID) => {
        const qBreak = quantityBreak.filter(discount => discount.PK_Stock_ID === StockID && ((discount.snt_QuantityBreak || 0) <= quantity))
            .sort((a, b) => (b.snt_QuantityBreak || 0) - (a.snt_QuantityBreak || 0))[0];
        if (qBreak) {
            return qBreak.dec_Discount;
        }
        else {
            return "0";
        }
    }

    // Calculation function
    const calculateNetSalesPrice = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {
        //Customer Discount 
        debugger;
        let TotalAmount = (salesPrice * dec_Quantity);
        if (customertaxType === "3" || customertaxType === 3) {
            TotalAmount = (TotalAmount) * ((100 - customerTax) / 100);
        }
        if (customertaxType === "4" || customertaxType === 4) {
            TotalAmount = TotalAmount - customerTax;
        }
        // END Customer Discount
        const StockDetail = customerStockList.filter(x => x.FK_Stock_ID === StockID);
        if (StockDetail.length > 0) {
            //Customer Discount Category 1
            if (customerCategorytaxType === "3" || customerCategorytaxType === 3) {
                TotalAmount = (TotalAmount) * ((100 - customerCategoryTax) / 100);
            }
            if (customerCategorytaxType === "4" || customerCategorytaxType === 4) {
                TotalAmount = TotalAmount - customerCategoryTax;
            }
            //END Customer Discount Category 1
            //Level 3 Discount
            const QuanitityDiscount = calculateQuantityBreakDiscount(dec_Quantity, StockID);
            if (quantityBreak.length > 0) {
                TotalAmount = (TotalAmount) * ((parseFloat(100).toFixed(2) - parseFloat(QuanitityDiscount).toFixed(2)) / 100);
            }
        }
        return parseFloat(TotalAmount).toFixed(2);
    };
    const calculateDiscountAmount = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {

        //Customer Discount 
        let TotalAmount = (salesPrice * dec_Quantity);
        let cusDiscountAmount = 0;
        if (customertaxType === "3" || customertaxType === 3) {
            cusDiscountAmount = (TotalAmount) * (customerTax / 100);
            TotalAmount = (TotalAmount) * ((100 - customerTax) / 100);
        }
        if (customertaxType === "4" || customertaxType === 4) {
            cusDiscountAmount = customerTax;
            TotalAmount = TotalAmount - customerTax;
        }
        //End Customer Discount 
        //Customer Discount Category 1
        const StockDetail = customerStockList.filter(x => x.FK_Stock_ID === StockID);
        if (StockDetail.length > 0) {
            if (customerCategorytaxType === "3" || customerCategorytaxType === 3) {
                cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat((TotalAmount) * (customerCategoryTax / 100)).toFixed(2));
                TotalAmount = (TotalAmount) * ((100 - customerCategoryTax) / 100);
            }
            if (customerCategorytaxType === "4" || customerCategorytaxType === 4) {
                cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat(customerCategoryTax).toFixed(2));
                TotalAmount = TotalAmount - customerCategoryTax;
            }
            //END Customer Discount Category 1
            //Level 3 Discount
            const QuanitityDiscount = calculateQuantityBreakDiscount(dec_Quantity, StockID);
            if (quantityBreak.length > 0) {
                cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat((TotalAmount) * (QuanitityDiscount / 100)).toFixed(2));
                TotalAmount = (TotalAmount) * ((parseFloat(100).toFixed(2) - parseFloat(QuanitityDiscount).toFixed(2)) / 100);
            }
        }
        //End Level 3 Discoutn
        return parseFloat(cusDiscountAmount).toFixed(2);
    };
    const calculateDiscountPrice = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {
        const vatTaxPercent = vatTax;

        //Customer Discount
        let TotalAmount = (salesPrice * dec_Quantity);
        if (customertaxType === "3" || customertaxType === 3) {
            TotalAmount = (TotalAmount) * ((100 - customerTax) / 100);
        }
        if (customertaxType === "4" || customertaxType === 4) {
            TotalAmount = TotalAmount - customerTax;

        }
        // END Customer Discount
        //Customer Discount Category 1
        const StockDetail = customerStockList.filter(x => x.FK_Stock_ID === StockID);
        if (StockDetail.length > 0) {
            if (customerCategorytaxType === "3" || customerCategorytaxType === 3) {
                TotalAmount = (TotalAmount) * ((100 - customerCategoryTax) / 100);
            }
            if (customerCategorytaxType === "4" || customerCategorytaxType === 4) {
                TotalAmount = TotalAmount - customerCategoryTax;

            }
            //End Customer Discount Category 1
            //Level 3 Discount
            const QuanitityDiscount = calculateQuantityBreakDiscount(dec_Quantity, StockID);
            if (quantityBreak.length > 0) {
                TotalAmount = (TotalAmount) * ((parseFloat(100).toFixed(2) - parseFloat(QuanitityDiscount).toFixed(2)) / 100);
            }
        }
        // End Level 3 Discount
        let newPrice = (TotalAmount * vatTaxPercent) / 100;
        return (newPrice).toFixed(2);
    };

    const handleSalesPriceChange = (index, newSalesPrice, fieldName) => {
        if (fieldName === "mon_SalesPrice") {
            const updatedParts = selectedParts.map((part, i) => {
                if (i === index) {
                    const netPrice = calculateNetSalesPrice(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    const VATPrice = calculateDiscountPrice(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    const dec_Discount = calculateDiscountAmount(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    return {
                        ...part,
                        mon_SalesPrice: newSalesPrice.value,
                        net_SalesPrice: netPrice,
                        net_VATPrice: VATPrice,
                        dec_Discount: dec_Discount
                    };
                }
                return part;
            });
            setSelectedParts(updatedParts);
        }
        else if (fieldName === "vc_UnitOfSale") {

            const updatedParts = selectedParts.map((part, i) => {
                if (i === index) {


                    const netPrice = calculateNetSalesPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice.value, part.dec_Discount, part.PK_Stock_ID);
                    const VATPrice = calculateDiscountPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice.value, part.dec_Discount, part.PK_Stock_ID);
                    const dec_Discount = calculateDiscountAmount(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    return {
                        ...part,
                        vc_UnitOfSale: newSalesPrice.value,
                        net_SalesPrice: netPrice,
                        net_VATPrice: VATPrice,
                        dec_Discount: dec_Discount
                    };
                }
                return part;
            });

            // Calculate the sum of mon_SalesPrice and net_SalesPrice
            let totalDiscountedAmount = 0;
            if (formData.int_DiscountType === "3") {
                const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_StockPrice), 0);
                const totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.net_SalesPrice), 0);
                totalDiscountedAmount = totalSalesPrice - totalNetSalesPrice;
            }
            else if (formData.int_DiscountType === "4") {

                totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount), 0);
            }
            // Update the state with the new parts and the total discounted amount
            setSelectedParts(updatedParts);

        }
    };


    const handleQuantityChange = (index, newSalesPrice) => {
        const updatedParts = selectedParts.map((part, i) => {
            if (i === index) {
                const netPrice = calculateNetSalesPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                const VATPrice = calculateDiscountPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                const dec_Discount = calculateDiscountAmount(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                return {
                    ...part,
                    vc_UnitOfSale: newSalesPrice,
                    net_SalesPrice: netPrice,
                    net_VATPrice: VATPrice,
                    dec_Discount: dec_Discount
                };
            }
            return part;
        });

        // Calculate the sum of mon_SalesPrice and net_SalesPrice
        let totalDiscountedAmount = 0;
        if (formData.int_DiscountType === "3") {
            const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_SalesPrice), 0);
            const totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.net_SalesPrice), 0);
            const totalDiscountedAmount = totalSalesPrice - totalNetSalesPrice;
        }
        else if (formData.int_DiscountType === "4") {
            totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount), 0);
        }
        // Update the state with the new parts and the total discounted amount
        setSelectedParts(updatedParts);

    };

    const handleBranchChange = async (event) => {
        const { value } = event.target;
        const branchID = event.target.value;
        setFormData({
            ...formData,
            FK_ClientBranch_ID: value,
            FK_ClientContact_ID: 0
        });
        await fetchCustomerContact(value);

    };


    const handlePartChange = (event, index, fieldName) => {
        const { value } = event.target;
        const updatedParts = [...selectedParts];
        const part = updatedParts[index];
        part[fieldName] = value;

        if (fieldName === "mon_SalesPrice") {

            part.net_SalesPrice = calculateNetSalesPrice(value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
            part.net_VATPrice = calculateDiscountPrice(value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
        }

        setSelectedParts(updatedParts);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/QuotationsList?saved=true');
            };
            debugger;
            formData.PK_Quotation_ID = QuotationID;
            formData.ID = QuotationID;
            formData.snt_PaymentMethod = "4";
            formData.mon_DeliveryNetTotal = "0.00";
            formData.mon_DeliveryVATTotal = "0.00";
            formData.FK_Currency_ID = "0";
            formData.OpportunityID = formData.OpportunityID > 0
                ? formData.OpportunityID
                : OpportunityID;
            formData.currencyCustomerSymbol1 = currencyCustomerSymbol1 || BaseCurrency;
            formData.BaseCurrency = BaseCurrency;
            const targetCurrency = currencyCustomerSymbol1 || BaseCurrency;
            const ConversionRate = await convertCurrency(BaseCurrency, targetCurrency, currencyList, "0");
            const selectedPartsData = await Promise.all(selectedParts.map(async (detail) => {
                const convertedStockPrice = (detail.mon_StockPrice / ConversionRate);
                const convertedmon_SalesPrice = (detail.mon_SalesPrice / ConversionRate);
                const convertednet_SalesPrice = (detail.net_SalesPrice / ConversionRate);
                const converteddetailnet_VATPrice = (detail.net_VATPrice / ConversionRate);
                const convertedmon_SellingPrice = (detail.mon_SellingPrice / ConversionRate);
                return {
                    vc_StockCode: detail.vc_StockCode,
                    vc_Description: detail.vc_Description,
                    mon_StockPrice: convertedStockPrice, // Use the converted price
                    mon_SalesPrice: convertedmon_SalesPrice,
                    dec_Quantity: detail.dec_Quantity,
                    vc_UnitOfSale: detail.vc_UnitOfSale,
                    net_SalesPrice: convertednet_SalesPrice,
                    net_VATPrice: converteddetailnet_VATPrice,
                    vc_StockName: detail.vc_Description,
                    PK_Stock_ID: detail.FK_Stock_ID,
                    dec_Discount: detail.dec_Discount,
                    mon_SellingPrice: convertedmon_SellingPrice,
                    vc_CommodityCode: detail.vc_CommodityCode,
                    dec_TaxCode: detail.dec_TaxCode,
                    dec_UnitWeight: detail.dec_UnitWeight,
                    snt_PurchaseNominalCode: detail.snt_PurchaseNominalCode,
                    dec_VAT: detail.dec_VAT,
                    mon_VATPriceForeignCurrency: detail.mon_VATPriceForeignCurrency,
                    PK_Stock_ID: detail.PK_Stock_ID,
                };
            }));

            const formDataWithParts = {
                formData: formData,
                selectedParts: selectedPartsData
            };
            debugger;
            CustomerType = formData.type;
            const response = await handleSubmit(event, formDataWithParts, setFormData, setErrors);
            debugger;
            if (response.message == "Data saved successfully") {
                setIsChanged(false);
                onSuccess();

                localStorage.setItem('HasRecordUpdated', "1");
                localStorage.setItem(CustomerType, formData.type);
                QuotationID = response.QuotationID;
                setShowSuccessMessage(true);
                await resetForm();
                setSelectedParts([]);
                debugger;
                await handleUserDefineSubmit({
                    JobID: QuotationID,
                    fields: KeyNameList.map(key => ({
                        PK_KeyName_ID: key.PK_KeyName_ID,
                        value: formData[key.vc_Name] || ''
                    }))
                });
                debugger;
                fetchKeyNames();
                // await fetchQuotationDetail();
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);

                await fetchQuotationDetail(CustomerType);
                //redirectUserList();
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };

    const handleCustomerSelect = async (customer) => {
        debugger;
        if (customer.CType === "Customer") {
            setFormData(prev => ({
                ...prev,
                ...formData,
                type: "1",
                CustomerID: customer.ClientCompanyID,
                CustomerName: customer.CompanyName,
                AccountRef: customer.AccountRef,
                FK_ClientBranch_ID: 0,
                FK_ClientContact_ID: 0,
                OpportunityID: 0,
                OpportunityName: "",
                BranchName: customer.BranchName,
            }));

            //  fetchParts(customer.ClientCompanyID);
            const newCurrencySymbol = (customer.vc_CurrencySymbol != null && customer.vc_CurrencySymbol !== "" && customer.vc_CurrencySymbol !== "undefined")
                ? customer.vc_CurrencySymbol
                : BaseCurrency;
            const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");

            // Level 1 Discount
            setCustomerTax(customer.dec_Amount ?? 0.00);
            setCustomertaxType(customer.FK_DiscountType_ID ?? 0);
            // END Level 1 Discount

            // Level 2 Discount

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CustomerStock = await fetchCustomerStock(customer.ClientCompanyID);
            if (CustomerStock.length > 0) {
                setCustomerCategoryType(CustomerStock[0].FK_DiscountType_ID);
                setCustomerCategoryTax(CustomerStock[0].dec_Amount);

                const StockCategryList = await StockDiscountCategoryService.GetStockByCategoryID(redirectCallback, CustomerStock[0].FK_StockCategory_ID);
                setCustomerStockList(StockCategryList);
                // Level 3 Discount
                let QuantityBreakDiscount = await fetchCustomerCategoryDiscount(CustomerStock[0].FK_StockCategory_ID);
                setQuantityBreak(QuantityBreakDiscount);
            }
            //End Level 2 Discount

            setVatTax(customer.dec_Rate ?? 0.00);
            setCurrencyCustomerSymbol1(newCurrencySymbol);
            setConRate(ConversionRate);
            if (QuotationID > 0) {
                await fetchQuotationItems(newCurrencySymbol, ConversionRate);
            }
            else {

                const selectedPartsData = await Promise.all(selectedParts.map(async (detail) => {
                    const convertedStockPrice = (detail.mon_StockPrice * ConversionRate);
                    const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                    const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                    const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                    const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);
                    return {
                        vc_StockCode: detail.vc_StockCode,
                        vc_Description: detail.vc_Description,
                        mon_StockPrice: convertedStockPrice, // Use the converted price
                        mon_SalesPrice: convertedmon_SalesPrice,
                        dec_Quantity: detail.dec_Quantity,
                        net_SalesPrice: convertednet_SalesPrice,
                        net_VATPrice: converteddetailnet_VATPrice,
                        vc_StockName: detail.vc_Description,
                        PK_Stock_ID: detail.FK_Stock_ID,
                        dec_Discount: detail.dec_Discount,
                        mon_SellingPrice: convertedmon_SellingPrice,
                        // Map other fields as needed
                    };
                }));
                setSelectedParts(selectedPartsData);
            }


            await fetchCustomersSites(customer.ClientCompanyID);
            fetchCustomerContact(customer.ClientBranchID);
            setShowCustomerModal(false);
            setOpportunityModal(false);
        }
        else if (customer.CType === "Opportunity") {
            setFormData({
                ...formData,
                type: "3",
                OpportunityID: customer.ClientCompanyID,
                OpportunityName: customer.CompanyName,
                FK_ClientBranch_ID: 0,
                FK_ClientContact_ID: 0

            });
            //  await fetchParts(0);
            const newCurrencySymbol = (customer.vc_CurrencySymbol != null && customer.vc_CurrencySymbol !== "" && customer.vc_CurrencySymbol !== "undefined")
                ? customer.vc_CurrencySymbol
                : BaseCurrency;
            const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
            setCurrencyCustomerSymbol1(newCurrencySymbol);
            setVatTax(customer.dec_Rate ?? 0.00);
            setConRate(ConversionRate);
            setOpportunityModal(false);
            setShowCustomerModal(false);
        }
    };

    const handleLeadSelect = async (lead) => {
        setFormData({
            ...formData,
            type: "2",
            LeadID: lead.ID,
            LeadName: lead.vc_Company

        });
        //   await fetchParts(0);
        const newCurrencySymbol = (lead.vc_CurrencySymbol != null && lead.vc_CurrencySymbol !== "" && lead.vc_CurrencySymbol !== "undefined")
            ? lead.vc_CurrencySymbol
            : BaseCurrency;
        const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
        setCurrencyCustomerSymbol1(newCurrencySymbol);
        setVatTax(lead.dec_Rate ?? 0.00);
        setConRate(ConversionRate);
        setLeadModal(false);
    };

    const handleOpportunitySelect = async (customer) => {
        debugger;
        if (customer.CType === "Customer") {
            setFormData(prev => ({
                ...prev,
                ...formData,
                type: "1",
                CustomerID: customer.ID,
                CustomerName: customer.CompanyName,
                AccountRef: customer.AccountRef,
                FK_ClientBranch_ID: 0,
                FK_ClientContact_ID: 0,
                OpportunityID: 0,
                OpportunityName: "",
            }));

            //  fetchParts(customer.ClientCompanyID);
            const newCurrencySymbol = (customer.vc_CurrencySymbol != null && customer.vc_CurrencySymbol !== "" && customer.vc_CurrencySymbol !== "undefined")
                ? customer.vc_CurrencySymbol
                : BaseCurrency;
            const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");

            // Level 1 Discount
            setCustomerTax(customer.dec_Amount ?? 0.00);
            setCustomertaxType(customer.FK_DiscountType_ID ?? 0);
            // END Level 1 Discount

            // Level 2 Discount

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CustomerStock = await fetchCustomerStock(customer.ID);
            if (CustomerStock.length > 0) {
                setCustomerCategoryType(CustomerStock[0].FK_DiscountType_ID);
                setCustomerCategoryTax(CustomerStock[0].dec_Amount);

                const StockCategryList = await StockDiscountCategoryService.GetStockByCategoryID(redirectCallback, CustomerStock[0].FK_StockCategory_ID);
                setCustomerStockList(StockCategryList);
                // Level 3 Discount
                let QuantityBreakDiscount = await fetchCustomerCategoryDiscount(CustomerStock[0].FK_StockCategory_ID);
                setQuantityBreak(QuantityBreakDiscount);
            }
            //End Level 2 Discount

            setVatTax(customer.dec_Rate ?? 0.00);
            setCurrencyCustomerSymbol1(newCurrencySymbol);
            setConRate(ConversionRate);
            if (QuotationID > 0) {
                await fetchQuotationItems(newCurrencySymbol, ConversionRate);
            }
            else {

                const selectedPartsData = await Promise.all(selectedParts.map(async (detail) => {
                    const convertedStockPrice = (detail.mon_StockPrice * ConversionRate);
                    const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                    const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                    const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                    const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);
                    return {
                        vc_StockCode: detail.vc_StockCode,
                        vc_Description: detail.vc_Description,
                        mon_StockPrice: convertedStockPrice, // Use the converted price
                        mon_SalesPrice: convertedmon_SalesPrice,
                        dec_Quantity: detail.dec_Quantity,
                        net_SalesPrice: convertednet_SalesPrice,
                        net_VATPrice: converteddetailnet_VATPrice,
                        vc_StockName: detail.vc_Description,
                        PK_Stock_ID: detail.FK_Stock_ID,
                        dec_Discount: detail.dec_Discount,
                        mon_SellingPrice: convertedmon_SellingPrice,
                        // Map other fields as needed
                    };
                }));
                setSelectedParts(selectedPartsData);
            }


            await fetchCustomersSites(customer.ID);
            setShowCustomerModal(false);
            setOpportunityModal(false);
        }
        else if (customer.CType === "Opportunity") {
            setFormData({
                ...formData,
                type: "3",
                OpportunityID: customer.ID,
                OpportunityName: customer.CompanyName,
                FK_ClientBranch_ID: 0,
                FK_ClientContact_ID: 0

            });
            //  await fetchParts(0);
            const newCurrencySymbol = (customer.vc_CurrencySymbol != null && customer.vc_CurrencySymbol !== "" && customer.vc_CurrencySymbol !== "undefined")
                ? customer.vc_CurrencySymbol
                : BaseCurrency;
            const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
            setCurrencyCustomerSymbol1(newCurrencySymbol);
            setVatTax(customer.dec_Rate ?? 0.00);
            setConRate(ConversionRate);
            setShowCustomerModal(false);
            setOpportunityModal(false);
        }
    };

    const handlePartSelect = async (selectedPartsArray) => {
        debugger;
        const targetCurrency = currencyCustomerSymbol1 || BaseCurrency;
        const ConversionRate = await convertCurrency(BaseCurrency, targetCurrency, currencyList, "0");
        const convertedParts = selectedPartsArray.map(part => {
            const convertedStockPrice = (part.mon_StockPrice * ConversionRate);
            const convertedmon_SalesPrice = (part.mon_SalesPrice * ConversionRate);
            const convertednet_SalesPrice = (part.net_SalesPrice * ConversionRate);
            const converteddetailnet_VATPrice = (part.net_VATPrice * ConversionRate);
            const convertedmon_SellingPrice = (part.mon_SellingPrice * ConversionRate);


            return {
                ...part,
                mon_StockPrice: convertedStockPrice,
                mon_SalesPrice: convertedmon_SalesPrice,
                mon_SellingPrice: convertedmon_SalesPrice,
                dec_Discount: calculateDiscountAmount(convertedmon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, formData.dec_DiscountAmount, part.PK_Stock_ID),
                net_SalesPrice: calculateNetSalesPrice(convertedmon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, formData.dec_DiscountAmount, part.PK_Stock_ID),
                net_VATPrice: calculateDiscountPrice(parseFloat(convertedmon_SalesPrice || 0), formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, formData.dec_DiscountAmount, part.PK_Stock_ID),

            };
        });
        setSelectedParts(prev => [...prev, ...convertedParts]);
        setShowPartModal(false);

    };

    const fetchQuotationItems = async (currencySymbol, ConversionRate) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            if (QuotationID > 0) {

                const quotationDetails = await QuotationService.GetQuotationItem(redirectCallback, QuotationID, CustomerType);


                const selectedPartsData = await Promise.all(quotationDetails.map(async (detail) => {
                    const convertedStockPrice = parseFloat(detail.mon_StockPrice * ConversionRate).toFixed(2);
                    const convertedmon_SalesPrice = parseFloat(detail.mon_SalesPrice * ConversionRate).toFixed(2);
                    const converteddec_VAT = parseFloat(detail.dec_VAT * ConversionRate).toFixed(2);
                    const converteddec_Quantity = parseFloat(detail.dec_Quantity * ConversionRate).toFixed(2);
                    const convertednet_SalesPrice = parseFloat(detail.net_SalesPrice * ConversionRate).toFixed(2);
                    const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                    const convertedmon_SellingPrice = parseFloat(detail.mon_SellingPrice * ConversionRate).toFixed(2);

                    return {
                        vc_StockCode: detail.vc_StockCode,
                        vc_Description: detail.vc_Description,
                        mon_StockPrice: convertedStockPrice, // Use the converted price
                        mon_SalesPrice: convertedmon_SalesPrice,
                        dec_Quantity: detail.dec_Quantity,
                        net_SalesPrice: parseFloat(convertednet_SalesPrice).toFixed(2),
                        net_VATPrice: parseFloat(converteddec_VAT).toFixed(2),
                        vc_StockName: detail.vc_Description,
                        PK_Stock_ID: detail.FK_Stock_ID,
                        dec_Discount: detail.dec_Discount,
                        mon_SellingPrice: convertedmon_SellingPrice,
                        vc_UnitOfSale: detail.vc_UnitOfSale,
                        // Map other fields as needed
                    };
                }));
                setSelectedParts(selectedPartsData);
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };

    const removeRow = (index) => {
        const updatedTableData = [...selectedParts];
        updatedTableData.splice(index, 1);
        setSelectedParts(updatedTableData);
    };

    const handleAddRow = () => {
        const newRow = {
            PK_Stock_ID: 0,
            vc_StockCode: "S1",            // Default Product Code
            vc_Description: "Free Text",            // Default Description (Free text)
            mon_SalesPrice: "0.00",        // Default Sale Price
            vc_UnitOfSale: "0.00",
            dec_Discount: "0.00",
            net_SalesPrice: "0.00",
            net_VATPrice: "0.00",
            mon_StockPrice: "0.00",
            dec_Quantity: "0",
            mon_SellingPrice: "0.00",
            dec_Allocated: "0.00",
            dec_FreeStock: "0.00",
            mon_AverageCostPrice: "0.00",
            mon_LastPurchasePrice: "0.00",

            isNew: true  // This will help identify newly added rows
        };
        setSelectedParts([...selectedParts, newRow]);
    };
    const { handleServiceJob } = useServiceJob(setLoading, setSelectedParts, tableRef, []);
    const handleCreateServiceJob = async (event) => {
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        if (QuotationID > 0) {
            const quotationDetail = await QuotationDetail(QuotationID);
            if (quotationDetail[0].FK_Issue_ID > 0 || quotationDetail[0].FK_SalesOrder_ID > 0) {
                Swal.fire(
                    'Error!',
                    'Sales Order or Service job already exist for the selected quotation.',
                    'warning'
                );
            }
            else {

                const result = await Swal.fire({
                    title: 'Are you sure?',
                    text: "Create service job from the selected quotation!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Create it!'
                });

                if (result.isConfirmed) {
                    setLoading(true);
                    try {

                        if (formData.OpportunityID > 0) {
                            const Customer = await CreateCustomer(event, formData.OpportunityID, "0");
                            const CustomerID = Customer.CustomerID;
                            debugger;
                            const CustomerDetail = await CustomerService.GetCustomerByID(redirectCallback, CustomerID);
                            debugger;
                            formData.CustomerID = CustomerID;
                            formData.FK_ClientBranch_ID = CustomerDetail[0].ClientBranchID;
                            formData.FK_ClientContact_ID = CustomerDetail[0].ClientContactID;
                            formData.ClientType = "1";
                        }


                        const message = await handleServiceJob(event, QuotationID);
                        if (message === "Data Saved") {
                            await QuotationService.RestoreClient(formData.CustomerID);
                            Swal.fire(
                                'Success!',
                                'Serviec Jon Created Successfully.',
                                'warning'
                            );
                            SetIsClosed("1");
                            await fetchQuotationDetail(CustomerType);
                            onClose();
                        }
                    } catch (error) {
                        console.error('Error fetching Teams:', error);
                    }
                    finally {
                        setLoading(false); // Stop loading after fetching
                    }
                }
            }
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to create a service job.',
                'warning'
            );
        }

    };
    const QuotationDetail = async (QuotationID) => {
        try {
            const redirectCallback = () => navigate('/');
            const quotationDetail = await QuotationService.GetQuotationByID(redirectCallback, QuotationID);
            return quotationDetail;
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const { handleSaleOrder } = useSaleOrder(setLoading, setSelectedParts, tableRef, []);
    const handleCreateSaleOrder = async (event) => {


        const redirectCallback = () => navigate('/');
        if (QuotationID > 0) {
            const quotationDetail = await QuotationDetail(QuotationID);
            if (quotationDetail[0].FK_Issue_ID > 0 || quotationDetail[0].FK_SalesOrder_ID > 0) {
                Swal.fire(
                    'Error!',
                    'Sales Order or Service job already exist for the selected quotation.',
                    'warning'
                );
            }
            else {

                const result = await Swal.fire({
                    title: 'Are you sure?',
                    text: "Create Sales Order from the selected quotation!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Create it!'
                });

                if (result.isConfirmed) {
                    setLoading(true);
                    try {

                        if (formData.OpportunityID > 0) {
                            const Customer = await CreateCustomer(event, formData.OpportunityID, "0");
                            const CustomerID = Customer.CustomerID;
                            debugger;
                            const CustomerDetail = await CustomerService.GetCustomerByID(redirectCallback, CustomerID);
                            debugger;
                            formData.CustomerID = CustomerID;
                            formData.FK_ClientBranch_ID = CustomerDetail[0].ClientBranchID;
                            formData.FK_ClientContact_ID = CustomerDetail[0].ClientContactID;
                            formData.ClientType = "1";
                        }

                        const message = await handleSaleOrder(event, QuotationID);
                        if (message === "Data Saved") {
                            await QuotationService.RestoreClient(formData.CustomerID);
                            Swal.fire(
                                'Success!',
                                'Sales Order Created Successfully.',
                                'warning'
                            );
                            SetIsClosed("1");
                            await fetchQuotationDetail(CustomerType);
                            onClose();
                        }
                    }
                    catch (error) {
                        console.error('Error fetching Teams:', error);
                    }
                    finally {
                        setLoading(false); // Stop loading after fetching
                    }
                }

            }
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to create a service job.',
                'warning'
            );
        }


    };
    const { handleInvoice } = useInvoice(setLoading, setSelectedParts, tableRef, []);
    const handleCreateInvoice = async (event) => {
        debugger;

        const redirectCallback = () => navigate('/');
        if (QuotationID > 0) {
            const quotationDetail = await QuotationDetail(QuotationID);
            if (quotationDetail[0].FK_Issue_ID > 0 || quotationDetail[0].FK_SalesOrder_ID > 0) {
                Swal.fire(
                    'Error!',
                    'Sales Order or Service job already exist for the selected quotation.',
                    'warning'
                );
            }
            else {

                const result = await Swal.fire({
                    title: 'Are you sure?',
                    text: "Create invoice from the selected quotation!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Create it!'
                });

                if (result.isConfirmed) {
                    setLoading(true);
                    try {

                        if (formData.OpportunityID > 0) {
                            const Customer = await CreateCustomer(event, formData.OpportunityID, "0");
                            const CustomerID = Customer.CustomerID;
                            debugger;
                            const CustomerDetail = await CustomerService.GetCustomerByID(redirectCallback, CustomerID);
                            debugger;
                            formData.CustomerID = CustomerID;
                            formData.FK_ClientBranch_ID = CustomerDetail[0].ClientBranchID;
                            formData.FK_ClientContact_ID = CustomerDetail[0].ClientContactID;
                            formData.ClientType = "1";
                        }


                        const message = await handleInvoice(event, QuotationID);
                        if (message === "Data Saved") {
                            await QuotationService.RestoreClient(formData.CustomerID);
                            Swal.fire(
                                'Success!',
                                'Invoice Created Successfully.',
                                'warning'
                            );
                            SetIsClosed("1");
                            await fetchQuotationDetail(CustomerType);
                            onClose();
                        }
                    }
                    catch (error) {
                        console.error('Error fetching Teams:', error);
                    }
                    finally {
                        setLoading(false); // Stop loading after fetching
                    }
                }

            }
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to create a service job.',
                'warning'
            );
        }


    };
    const truncateTextPdf = (text, maxLength = 25) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const [imageData, setImageData] = useState(null);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }

                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);
    const getMergedPDFBlob = async (includeTerms = true) => {

        try {

            const currentInputValues = {
                ClientID: localStorage.getItem("CompanyID"),
                ID: QuotationID
            };

            const redirectCallback = () => {
                navigate('/');
            };

            // ================= MAIN REPORT =================

            let reportData = await ReportService.GetCompanyReports(
                redirectCallback,
                "6"
            );

            reportData = reportData.filter(
                x => x.IsDefault.toString() === "1"
            );

            const reportID =
                reportData.length > 0
                    ? reportData[0].ID
                    : 108;

            const JasperReport =
                await JasperReportService.GetJasperReportByID(reportID);

            let url = JasperReport[0].Link;

            setReportLink(url);

            setReportTitle(JasperReport[0].ReportTitle);

            // replace placeholders in main report
            Object.keys(currentInputValues).forEach((key) => {

                const placeholder = new RegExp(`{${key}}`, 'g');

                let value = currentInputValues[key];

                if (key === "ClientID") {

                    value = localStorage.getItem("CompanyID");

                } else if (key === "UserID") {

                    value = localStorage.getItem("UserID");

                }

                if (url.includes(`{${key}}`)) {

                    url = url.replace(placeholder, value);

                }

            });

            const queryObjMain = {
                ...currentInputValues,
                format: 'pdf',
                ReportName: JasperReport[0].ReportName,
                ReportType: JasperReport[0].ReportType,
                name: JasperReport[0].ReportName
            };

            const queryStringMain =
                new URLSearchParams(queryObjMain).toString();

            const responseMain = await axiosInstance.get(
                `/Dashboard/ProxyReport?${queryStringMain}`,
                { responseType: 'blob' }
            );

            const mainPdfBytes =
                await responseMain.data.arrayBuffer();

            // ================= MERGE PDFs =================

            const mergedPdf = await PDFDocument.create();

            const mainPdf =
                await PDFDocument.load(mainPdfBytes);

            const mainPages =
                await mergedPdf.copyPages(
                    mainPdf,
                    mainPdf.getPageIndices()
                );

            mainPages.forEach((page) =>
                mergedPdf.addPage(page)
            );

            // ================= TERMS PDF =================

            if (includeTerms) {

                const companySetup =
                    await CompanySetupController.GetCompanyByID(
                        redirectCallback,
                        localStorage.getItem("CompanyID")
                    );

                const termFile =
                    companySetup?.[0]?.TermFile;

                // Only attach second PDF if file exists
                if (termFile) {

                    const ClientID =
                        localStorage.getItem('CompanyID');

                    const FileUrl =
                        `${BASE_URL}/uploads/${ClientID}/Admin/TermConditions/${termFile}`;

                    const responseSecond =
                        await axiosInstance.get(
                            FileUrl,
                            { responseType: 'blob' }
                        );

                    const secondPdfBytes =
                        await responseSecond.data.arrayBuffer();

                    const secondPdf =
                        await PDFDocument.load(secondPdfBytes);

                    const secondPages =
                        await mergedPdf.copyPages(
                            secondPdf,
                            secondPdf.getPageIndices()
                        );

                    secondPages.forEach((page) =>
                        mergedPdf.addPage(page)
                    );
                }
            }

            const mergedPdfBytes =
                await mergedPdf.save();

            return new Blob(
                [mergedPdfBytes],
                { type: "application/pdf" }
            );

        } catch (err) {

            console.error("Error executing report:", err);

            setError("Failed to execute the report.");

            return null;
        }
    };

    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const generatePDF = async (event) => {
        event.stopPropagation();

        try {
            const result = await Swal.fire({
                title: "Include Terms & Conditions?",
                text: "Do you want to include Terms & Conditions in the print?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes, include it",
                cancelButtonText: "No, just main report",
            });

            const includeTerms = result.isConfirmed;

            const blob = await getMergedPDFBlob(includeTerms);

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);

            localStorage.setItem('HasRecordUpdated', "1");

        } catch (err) {
            console.error(err);
        }
    };
    const generatePDFForEmail = async (termsFlag) => {
        try {
            setLoading(true);

            const blob = await getMergedPDFBlob(termsFlag);

            const file = new File([blob], 'Invoice.pdf', {
                type: 'application/pdf'
            });

            setPdfAttachment(file);
            setIsEmailModalOpen(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };
    const handleRadioChange = (event) => {
        const { value } = event.target;

        // Create a base object with `type` updated
        let updatedFormData = {
            ...formData,
            ClientType: value,
            type: value == 1 ? 3 : 1
        };

        // Extend `updatedFormData` with additional fields based on the selected value
        if (value === "1") {
            // setCustomerModal(true);
        } else if (value === "2") {
            // setLeadModal(true);
        } else if (value === "2") {
            // setOpportunityModal(true);
        }

        // Update the formData state with the final object
        setFormData(updatedFormData);
    };
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };

    const CreateCustomer = async (event, OpportunityID, quotationID) => {
        const LeadDetail = await fetchOpportunityDetail(OpportunityID);
        debugger;
        //  if (LeadDetail.ClientCompanyID < 1) {

        const formData = {
            ClientCompanyID: 0,
            FK_ClientCompanyType_ID: 0,
            ContactTypeID: "1",

            FK_LeadOpportunitySource_Id: LeadDetail.FK_LeadOpportunitySource_Id,
            FK_LeadOpportunityStatus_ID: LeadDetail.FK_LeadOpportunityStatus_ID,
            FK_TaxCode_ID: LeadDetail.FK_TaxCode_Id,
            FK_Currency_ID: LeadDetail.FK_Currency_Id,
            FK_Owner_Id: LeadDetail.FK_Owner_Id,
            TeamID: 0,
            CourierID: 0,
            CompanyName: LeadDetail.vc_Company,
            Title: LeadDetail.vc_Title,
            Forename: LeadDetail.vc_FirstName,
            Surname: LeadDetail.vc_Surname,
            Telephone: LeadDetail.vc_Phone,
            Mobile: LeadDetail.vc_Mobile,
            Email: LeadDetail.vc_Email,
            Address1: LeadDetail.vc_Address1,
            Address2: LeadDetail.vc_Address2,
            Address3: LeadDetail.vc_Address3,
            City: LeadDetail.vc_City,
            County: LeadDetail.vc_County,
            Country: LeadDetail.vc_Country,
            Website: LeadDetail.vc_Website,
            dec_Weight: LeadDetail.dec_Weight,
            vc_Topic: LeadDetail.vc_Topic,
            quotationID: quotationID,
            IndustrialSector: LeadDetail.IndustrialSector,
            NoOfEmployees: LeadDetail.NoOfEmployees,
            PostCode: LeadDetail.vc_Postcode,
            JobRoleID: LeadDetail.JobRoleID,

        }

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        formData.FromOpportunity = "1";
        formData.OpportunityID = OpportunityID;
        const formDataWithParts = {
            formData: formData,
            tableData: [],

        };
        const message = await handleCustomerSubmit(event, formDataWithParts, "", setErrors, redirectCallback, "", "1");
        debugger;
        return message;

    }

    const handleCustomerIDSelect = (event) => {

        setShowCustomerModal(true);

    }
    const handleAddNewItem = (event) => {
        debugger;
        if (formData.CustomerID > 0 || OpportunityID > 0) {
            setShowPartModal(true);
        }
        else {
            Swal.fire(
                'Warning!',
                'Please select company first.',
                'warning'
            );
        }
    }

    const [isSiteModalOpen, setIsSiteModalOpen] = useState(false);
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const handleCloseSiteSelectionModal = () => {
        setIsSiteModalOpen(false);
    };
    const handleCloseContactSelectionModal = () => {
        setIsContactModalOpen(false);
    };
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const handleSelectSite = async (site) => {

        setIsChanged(true);
        const CustomerSite = await CustomerSiteService.GetCustomerSiteByID(redirectCallback, site.ClientBranchID);

        if (CustomerSite && CustomerSite.length > 0) {
            setFormData(prevFormData => ({
                ...prevFormData,
                FK_ClientBranch_ID: site.ClientBranchID,
                Address1: CustomerSite[0].BranchAddress,

                BranchName: site.BranchName,
            }));

            fetchCustomerContact(site.ClientBranchID);
        } else {
            console.warn("No customer site found for ID", site.ClientBranchID);
        }


        handleCloseSiteSelectionModal();   // Close the modal
    };
    const handleSelectContact = async (contact) => {
        setIsChanged(true);
        setFormData(prevFormData => ({
            ...prevFormData,
            FK_ClientContact_ID: contact.ClientContactID,
            ContactName: contact.ContactName,
        }));

        handleCloseContactSelectionModal();   // Close the modal
    };
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <form onSubmit={handleFormSubmit} style={{
                // IE/Edge
            }}>
                <div

                >
                    <table style={{ width: "100%" }}>
                        <tbody>



                            <tr>
                                {formData.type?.toString() === '1' && formData.ClientType?.toString() === "0" && (
                                    <>
                                        <td style={{ width: "15%" }}>
                                            <label htmlFor="CustomerID" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td style={{ width: "35%" }}>


                                            <input
                                                type="text"
                                                className="form-control"
                                                id="CustomerID"
                                                name="CustomerID"
                                                value={formData.CustomerName}
                                                onClick={handleCustomerIDSelect}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}

                                            />
                                            {errors.CustomerID && <div style={{ color: 'red' }}>{errors.CustomerID}</div>}
                                        </td>
                                    </>
                                )
                                }
                                {formData.type?.toString() === '2' && (
                                    <>
                                        <td style={{ width: "15%" }}>
                                            <label htmlFor="LeadID" style={{ float: "right" }}>Select Lead <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td style={{ width: "35%" }}>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="LeadID"
                                                name="LeadID"
                                                value={formData.LeadName}
                                                onClick={() => setLeadModal(true)}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}

                                            />


                                            {errors.LeadID && <div style={{ color: 'red' }}>{errors.LeadID}</div>}
                                        </td>
                                    </>
                                )}
                                {formData.type?.toString() === '3' && formData.ClientType?.toString() === "0" && (
                                    <>
                                        <td style={{ width: "15%" }}>
                                            <label htmlFor="OpportunityID" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td style={{ width: "35%" }}>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="OpportunityID"
                                                name="OpportunityID"
                                                value={formData.OpportunityName}
                                                onClick={handleCustomerIDSelect}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}

                                            />
                                            {errors.OpportunityID && <div style={{ color: 'red' }}>{errors.OpportunityID}</div>}
                                        </td>
                                        <td style={{ width: "15%" }}></td>
                                        <td style={{ width: "35%" }}></td>
                                    </>
                                )}


                                {formData.type?.toString() === '1' && formData.ClientType?.toString() === "0" && (
                                    <>
                                        <td>
                                            <label htmlFor="vc_SerialNumber" style={{ float: "right" }}>Site :<span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="FK_ClientBranch_ID"
                                                name="FK_ClientBranch_ID"
                                                value={formData.BranchName}
                                                onClick={() => setIsSiteModalOpen(true)}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}

                                            />

                                            {errors.FK_ClientBranch_ID && <div style={{ color: 'red' }}>{errors.FK_ClientBranch_ID}</div>}
                                        </td>
                                    </>
                                )}
                            </tr>
                            {formData.type?.toString() === '1' && formData.ClientType?.toString() === "0" && (
                                <tr>
                                    <td>
                                        <label htmlFor="FK_ClientContact_ID" style={{ float: "right" }}>Contact <span style={{ "color": "red" }}>*</span></label>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="FK_ClientContact_ID"
                                            name="FK_ClientContact_ID"
                                            value={formData.ContactName}
                                            onClick={() => setIsContactModalOpen(true)}
                                            readOnly
                                            disabled={isClosed === '1' || isClosed === 1}

                                        />

                                        {errors.FK_ClientContact_ID && <div style={{ color: 'red' }}>{errors.FK_ClientContact_ID}</div>}
                                    </td>
                                    <td>
                                        <label htmlFor="AccountRef" style={{ float: "right" }}>Account Ref &nbsp;&nbsp;</label>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="AccountRef"
                                            name="AccountRef"
                                            value={formData.AccountRef}
                                            onChange={(e) => setFormData({ ...formData, AccountRef: e.target.value })}
                                            readOnly
                                            disabled={isClosed === '1' || isClosed === 1}
                                        />
                                    </td>
                                </tr>
                            )}
                            {formData.ClientType?.toString() === "1" && (
                                <>
                                    <tr>
                                        <td>
                                            <label htmlFor="ClientCompanyName" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="ClientCompanyName" value={formData.ClientCompanyName} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.ClientCompanyName && <div style={{ color: 'red' }}>{errors.ClientCompanyName}</div>}
                                        </td>
                                        <td>
                                            <label htmlFor="Forename" style={{ float: "right" }}>Forename <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="Forename" value={formData.Forename} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.Forename && <div style={{ color: 'red' }}>{errors.Forename}</div>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label htmlFor="Address1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="Address1" value={formData.Address1} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.Address1 && <div style={{ color: 'red' }}>{errors.Address1}</div>}
                                        </td>
                                        <td>
                                            <label htmlFor="dt_QuotationDate" style={{ float: "right" }}>Surname <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="Surname" value={formData.Surname} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.Surname && <div style={{ color: 'red' }}>{errors.Surname}</div>}
                                        </td>
                                    </tr>
                                </>

                            )}

                            <tr>
                                <td>
                                    <label htmlFor="vc_CustomerOrderNumber" style={{ float: "right" }}>Customer Order No &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_CustomerOrderNumber" value={formData.vc_CustomerOrderNumber} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_CustomerOrderNumber && <div style={{ color: 'red' }}>{errors.vc_CustomerOrderNumber}</div>}
                                </td>
                                <td>
                                    <label htmlFor="dt_QuotationDate" style={{ float: "right" }}>Order Date <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <input type="date" className="form-control" name="dt_QuotationDate" value={formData.dt_QuotationDate} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.dt_QuotationDate && <div style={{ color: 'red' }}>{errors.dt_QuotationDate}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="FK_QuotationStatus_ID" style={{ float: "right" }}>Status <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <select
                                        name="FK_QuotationStatus_ID"
                                        className='form-control'
                                        readOnly
                                        value={formData.FK_QuotationStatus_ID}
                                        onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}
                                    >
                                        <option value="0"> Quotation Status</option>
                                        {QuotationStatusList.map((quot) => (
                                            <option key={quot.PK_QuotationStatus_ID} value={quot.PK_QuotationStatus_ID} disabled={isClosed === '1' || isClosed === 1}>
                                                {quot.vc_StatusName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_QuotationStatus_ID && <div style={{ color: 'red' }}>{errors.FK_QuotationStatus_ID}</div>}
                                </td>
                                {(assignedModules.has(MODULE_IDS.Jobs) &&
                                    <>
                                        <td>
                                            <label htmlFor="FK_Issue_ID" style={{ float: "right" }}>Job No. &nbsp;&nbsp;</label>
                                        </td>
                                        <td>
                                            <input type="text" readOnly className="form-control" name="FK_Issue_ID" value={formData.FK_Issue_ID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />

                                        </td>
                                    </>
                                )}
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="vc_User5" style={{ float: "right" }}>Reference &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_User5" value={formData.vc_User5} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />

                                </td>
                                <td>
                                    <label htmlFor="" style={{ float: "right" }}><span style={{ "color": "red" }}></span></label>
                                </td>
                                <td>

                                </td>
                            </tr>
                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                        </tbody>
                    </table>
                    <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                        <div className='col-sm-12' >

                            <table className="table datatable table-bordered" style={{ "width": "100%" }}>
                                <thead>
                                    <tr>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Product Code</th>
                                        <th className="no-wrap" style={{ "width": "15%" }}>Description</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Cost Price</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Sales Price</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Selling Price</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Quantity</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Discount</th>

                                        <th className="no-wrap" style={{ "width": "10%" }}>Net</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>VAT</th>
                                        <th style={{ "width": "5%" }}>Actions</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div className='col-sm-12' style={{ "overflow-y": "auto", "maxHeight": "150px" }}>
                            <table className="table datatable table-bordered" style={{ "width": "100%" }}>
                                <tbody>
                                    {selectedParts.map((part, index) => (
                                        <tr key={index}>
                                            <td className="no-wrap" style={{ "width": "10%" }}>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={part.vc_StockCode}
                                                    readOnly="true"
                                                    onChange={(e) => handlePartChange(e, index, 'vc_StockCode')}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "15%" }}>
                                                <div
                                                    onMouseEnter={(e) => {
                                                        const rect = e.target.getBoundingClientRect();
                                                        setModalPosition({ top: rect.top + window.scrollY - 50, left: rect.left });
                                                        setDescriptionText(part.vc_Description);
                                                        setShowDescriptionModal(true);
                                                    }}
                                                    onMouseLeave={() => setShowDescriptionModal(false)}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control"

                                                        value={part.vc_Description}
                                                        onChange={(e) => {
                                                            const updatedPart = { ...part, vc_Description: e.target.value };
                                                            const updatedParts = [...selectedParts];
                                                            updatedParts[index] = updatedPart;
                                                            setSelectedParts(updatedParts);
                                                        }}
                                                        disabled={isClosed === '1' || isClosed === 1}
                                                    />
                                                </div>
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency}
                                                    initialCurrencyValue={part.mon_StockPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, mon_StockPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency}
                                                    initialCurrencyValue={part.mon_SellingPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, mon_SellingPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency} initialCurrencyValue={part.mon_SalesPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => handleSalesPriceChange(index, newValue, 'mon_SalesPrice')} />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={part.vc_UnitOfSale}
                                                    onChange={(e) => handleQuantityChange(index, e.target.value)}

                                                />


                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>

                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency}
                                                    initialCurrencyValue={part.dec_Discount}
                                                    currencyList={currencyList}
                                                    disabled={true}
                                                />
                                            </td>



                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency}
                                                    initialCurrencyValue={part.net_SalesPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, net_SalesPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency}
                                                    initialCurrencyValue={part.net_VATPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, net_VATPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td style={{ "width": "5%" }}>
                                                <button style={{ "background": "none", "border": "none" }} className={`text-danger ${parseInt(isLock) > 0 ? 'disabled' : ''}`} disabled={isLock.toString() === "1" || localStorage.getItem('LicenseExpired') == "1"} onClick={() => removeRow(index)}>
                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* Add more form fields as needed */}

                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Discount</label>
                        <div className="col-sm-4">
                            <select name="int_DiscountType" className='form-control' value={formData.int_DiscountType} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                <option value="0">Select Discount</option>
                                {DiscountsList.map((discount) => (
                                    <option key={discount.PK_DiscountType_ID} value={discount.PK_DiscountType_ID}>
                                        {discount.vc_Name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {formData.CourierID > 0 && (
                            <>
                                <label htmlFor="dec_DiscountAmount" className="col-sm-2 col-form-label">Carriage Cost</label>
                                <div className="col-sm-4">

                                    <input type='text' name="mon_DeliveryNetTotal" value={formData.mon_DeliveryNetTotal} onChange={handleFieldChange} class='form-control'></input>
                                </div>
                            </>
                        )}

                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-2 col-form-label">Discount Amount</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" name="dec_DiscountAmount" value={formData.dec_DiscountAmount} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                        </div>
                        <label htmlFor="dec_DiscountNETTotal" className="col-sm-2 col-form-label">Discount</label>
                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency}
                                initialCurrencyValue={formData.dec_DiscountNETTotal}
                                currencyList={currencyList}

                                disabled={true}
                            />

                        </div>

                        <div className="col-sm-2">

                        </div>
                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-6 col-form-label"></label>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Orders Total</label>
                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency}
                                initialCurrencyValue={formData.mon_TotalPrice}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency}
                                initialCurrencyValue={formData.mon_TotalPriceO}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-6 col-form-label"></label>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Grand Total</label>
                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1 || BaseCurrency}
                                initialCurrencyValue={formData.mon_TotalPriceG}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">
                            <CurrencyTextField
                                initialCurrencySymbol={BaseCurrency}
                                initialCurrencyValue={parseFloat(formData.mon_TotalPriceG) / parseFloat(convRate).toFixed(2)}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                    <div className="col-sm-7">
                        {(assignedModules.has(MODULE_IDS.Parts) &&
                            <button style={{ background: "#00796B" }} type="button" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleAddNewItem} disabled={isClosed === '1' || isClosed === 1 || isLock.toString() === "1" || !assignedModules.has(MODULE_IDS.Parts)}>
                                <i className="icofont-plus" aria-hidden="true">    Add Item</i>
                            </button>
                        )}
                        <button style={{ "marginLeft": "5px", background: "#0288D1" }} type="button" className={`btn btn-secondary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleAddRow} disabled={isClosed === '1' || isClosed === 1 || isLock.toString() === "1"}>
                            <i className="icofont-plus" aria-hidden="true">Add Text</i>
                        </button>

                        {(assignedModules.has(MODULE_IDS.Jobs) &&
                            <button style={{ "marginLeft": "5px", background: "#1565C0" }} type="button" className={`btn btn-success ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={(event) => handleCreateServiceJob(event, QuotationID)} disabled={isClosed === '1' || isClosed === 1 || QuotationID === 0 || QuotationID === "0" || CustomerType === "2" || LeadID > 0 || isLock.toString() === "1"}>
                                <img style={{ "width": "10px" }} src="assets/img/icons/btnIssuesD.png" alt="Add icon" /> Service Job
                            </button>
                        )}
                        {(assignedModules.has(MODULE_IDS.SalesOrders) &&
                            <button style={{ "marginLeft": "5px" }} type="button" className={`btn btn-dark ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={(event) => handleCreateSaleOrder(event, QuotationID)} disabled={isClosed === '1' || isClosed === 1 || QuotationID === 0 || QuotationID === "0" || LeadID > 0 || !assignedModules.has(MODULE_IDS.SalesOrders) || isLock.toString() === "1"}>
                                <img style={{ "width": "10px", background: "#283593" }} src="assets/img/icons/sale.png" alt="Add icon" />  Sales Order
                            </button>
                        )}
                        {(assignedModules.has(MODULE_IDS.Invoices) &&
                            <button style={{ "marginLeft": "5px", background: "#2E7D32" }} type="button" className={`btn btn-warning ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={(event) => handleCreateInvoice(event, QuotationID)} disabled={isClosed === '1' || isClosed === 1 || QuotationID === 0 || QuotationID === "0" || CustomerType === "2" || LeadID > 0 || !assignedModules.has(MODULE_IDS.SalesOrders) || isLock.toString() === "1"}>
                                <img style={{ "width": "10px" }} src="assets/img/icons/sale.png" alt="Add icon" />  Invoice
                            </button>
                        )}

                    </div>
                    <div className="col-sm-5">
                        <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                        </button>
                        <button style={{ "marginLeft": "5px", float: "right" }} type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} disabled={isClosed === '1' || isClosed === 1 || parseInt(isLock) > 0}>
                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                            {QuotationID > 0 ? ' Update' : ' Save'}

                        </button>
                        <button style={{ "marginLeft": "5px", float: "right" }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                            <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                        </button>
                        <button style={{ "marginLeft": "5px", float: "right" }} type="button" className="btn btn-email" onClick={() => generatePDFForEmail(includeTerms)}>
                            <i className="icofont-email" aria-hidden="true"></i> Email
                        </button>

                    </div>
                </div>
            </form>
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
            {(showDescriptionModal &&
                <DescriptionModal
                    show={showDescriptionModal}
                    text={descriptionText}
                    position={modalPosition}
                />
            )}
            <PartSelectionModal
                show={showPartModal}
                onClose={() => setShowPartModal(false)}
                parts={partList}
                onSelectPart={handlePartSelect}
                ClientCompanyID={formData.CustomerID}
            />
            {CustomerModal === true || formData.ClientType === "0" && (
                <CustomerSelectionModal
                    show={showCustomerModal}
                    onClose={() => setShowCustomerModal(false)}
                    customers={CustomerList}
                    onSelectCustomer={handleCustomerSelect}
                />
            )}
            {LeadModal === true && (
                <LeadSelectionModal
                    show={LeadModal}
                    onClose={() => setLeadModal(false)}
                    LeadList={LeadList}
                    onSelectLead={handleLeadSelect}
                />
            )}
            {OpportunityModal === true && (
                <OpportunitySelectionModal
                    show={OpportunityModal}
                    onClose={() => setOpportunityModal(false)}
                    OpportunityList={OpportunityList}
                    onSelectOpportunity={handleOpportunitySelect}
                />
            )}
            {isEmailModalOpen && (
                <SendEmail
                    onClose={handleCloseEmailModal}
                    ToEmail={Email}
                    pdfAttachment={pdfAttachment}
                    setPdfAttachment={setPdfAttachment}   // ✅ ADD THIS
                    getMergedPDFBlob={getMergedPDFBlob}   // ✅ ADD THIS
                    ReportName="Quotation.pdf"
                />
            )}

            {isSiteModalOpen && (
                <SiteSelectionModal
                    show={isSiteModalOpen}
                    onClose={handleCloseSiteSelectionModal}
                    onSelectSite={handleSelectSite}
                    ClientCompanyID={formData.CustomerID}
                />
            )}
            {isContactModalOpen && (
                <ContactSelectionModal
                    show={isContactModalOpen}
                    onClose={handleCloseContactSelectionModal}
                    onSelectContact={handleSelectContact}
                    ClientBranchID={formData.FK_ClientBranch_ID}
                />
            )}

        </div >


    );
}
export default QuotationDetail;

